// import { createIcons } from 'lucide';

/* -------------------------------------------------------------------------- */
/*                            Lucide Icons                                   */
/* -------------------------------------------------------------------------- */

const lucideIconsInit = () => {
  window.lucide.createIcons({
    attrs: {
        'stroke-width': 1.5,
        'class': 'lucide-icon',
        'width': '16',
        'height': '16'
    }
  });
};

export default lucideIconsInit; 